/**
 * Created by forbiz on 2019-02-11.
 */

const story = () => {
	const $window = $(window);
	const $document = $(document);

	const story_slider = {
		magazine_slider() {
			hdFn.hdSlide('.story__sec.magazine .magazine-list', {
				infinite: true,
				centerMode:true,
				arrows: true,
				dots: true,
  		 		//slidesToScroll: 1,
  		 		autoplay: true,
  				autoplaySpeed: 2000,
				variableWidth: true,
				asNavFor: '.story__sec.magazine .magazine-bg'
			});

			hdFn.hdSlide('.story__sec.magazine .magazine-bg', {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				asNavFor: '.story__sec.magazine .magazine-list'
			});

		},

		tv_slider() {
			hdFn.hdSlide('.story__sec.tv .tv-list', {
				autoplay: true,
  				autoplaySpeed: 3000,
				arrows: false,
				dots: true,
				infinite: true,
				speed: 300,
				variableWidth: true
			});
		},

		story_slider() {
			hdFn.hdSlide('.story__sec.eating .story-slider', {
				autoplay: true,
  				autoplaySpeed: 3000,
				arrows: true,
				dots: true,
				infinite: true,
				speed: 300,
				variableWidth: true
			});
		}
	}

	const parallax = () => {
		const $elm = $('.hPara').length > 0 ? $('.hPara') : false;

		$.each($elm, function () {
			const $this = $(this);

			$window.on('load scroll', function () {
				const _st = $window.scrollTop();
				const _view_height = $window.height();
				const _el_offset = $this.offset().top;
				const _el_height = $this.outerHeight(true);
				const _end_offset = _el_offset + _el_height;
				
				if (_el_offset < _st + _view_height) {
					if($this.hasClass('tv')){
						$this.addClass('active');
					} else if($this.hasClass('story-scroll')){
						var $ani = $this.data('animation');

						$this.find('.story-scroll-inner').css({'animation': $ani + ' 40s linear infinite'});
					} else if($this.hasClass('story-youtube')){

						// $this.find('iframe')[0].src += "?autoplay=1";
						// console.log(1)
					} else{
						$this.addClass('fadeInUp');
					}
				} else{
					if (_el_offset >= _st + _view_height) {
						if($this.hasClass('story-scroll')){
							$this.find('.story-scroll-inner').removeAttr('style');
						}
					}
				}
			});
		});
	};


	const storyinit = () => {
		parallax();
		story_slider.story_slider();
	};

	storyinit();

	window.story_slider = story_slider;
};

export default story;
